import { PIXELS_POINTS_UNIT_CONVERSION } from "./constants"
const isPortraitOrientation = (orientation) => {
  return orientation === 'P'
}
const transformCoordinates = (signature, toApi = false) => {
  const { x, y, ...rest } = signature
  if (toApi) {
    return {
      ...rest,
      x: Math.round(x * PIXELS_POINTS_UNIT_CONVERSION),
      y: Math.round(y * -PIXELS_POINTS_UNIT_CONVERSION)
    }
  }
  return {
    ...rest,
    x: Math.round(x / PIXELS_POINTS_UNIT_CONVERSION),
    y: Math.round((Math.abs(y) / PIXELS_POINTS_UNIT_CONVERSION))
  }
}
const imageDataToBlob = (data) => {
  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')
  canvas.width = data.width
  canvas.height = data.height
  ctx.putImageData(data, 0, 0)
  return new Promise((resolve => { canvas.toBlob((blob) => resolve(blob)) }))
}
const createImageBitmap = window.createImageBitmap || ((imageData) => {
  return new Promise((resolve) => {
    const img = document.createElement('img')
    img.addEventListener('load', (e) => resolve(img))
    imageDataToBlob(imageData).then((blob) => { img.src = URL.createObjectURL(blob) })
  })
})
const percentToPx = (sizeToConvert, percent) => sizeToConvert * (percent / 100)
const pxToPercent = (totalSize, sizeToConvert) => ( sizeToConvert / totalSize ) * 100
const coordinateByRotation = (r, ...args) => {
  const [ left, top, right, bottom ] = args
  const coords = {
    0: { left, top, right, bottom },
    90: { top, right, bottom, left },
    180: { right, bottom, left, top },
    270: { bottom, left, top, right }
  }
  return {
    coords: coords[r],
    points: [left, top, right, bottom]
  }
}
function rotateClockwise(angle, array) {
  if (angle === 0) return array
  const positions = angle / 90
  for (let i = 0; i < positions; i++) {
    const element = array.pop()
    array.unshift(element)
  }
  return array
}
function convertLastPage(numPage, totalPages, isInverted = false) {
  if (isInverted) return numPage === totalPages ? -1 : numPage
  return numPage === -1 ? totalPages : numPage
}

export {
  createImageBitmap,
  coordinateByRotation,
  isPortraitOrientation,
  percentToPx,
  pxToPercent,
  transformCoordinates,
  rotateClockwise,
  convertLastPage
}